export const WorkspaceCategoryPC = {
  None: 'None',
  AccountSettings: 'a4h83dj',
  ActionCenter: 'd8hwe3j',
  ApisAndIntegration: 'pm7xssm',
  Enrollment: 'wr1s1fg',
};

export const WorkspaceCategoryId = {
  AccountSettingsId: WorkspaceCategoryPC.AccountSettings,
  ActionCenterId: WorkspaceCategoryPC.ActionCenter,
  ApiAndIntegrationSupportId: WorkspaceCategoryPC.ApisAndIntegration,
  EnrollmentId: WorkspaceCategoryPC.Enrollment,
  ApiAndIntegrationSupportOldId: 'ApisAndIntegration',
  EnrollmentOldId: 'Enrollment',
  DeveloperTools: 'DeveloperTools',
  MicrosoftDynamics: 'MicrosoftDynamics',
  ProductSupport: 'ProductSupport',
  VolumeLicensing: 'VolumeLicensing',
};

export const WorkspacePC = {
  None: 'None',
  AppsAndGames: 'rr3q88o',
  Benefits: '2t2b7h0',
  Billing: 'oygi8p5',
  Collaborate: '8ukjom7',
  Customers: 'jtq6njt',
  Edge: '44xvqci',
  Hardware: '6z0naak',
  Incentives: 'xjayl89',
  Insights: 'lks5q3i',
  Membership: '29543yy',
  MarketplaceOffers: 'zp6h43v',
  Referrals: 'kwo9p6l',
  Earnings: '227z4kg',
  Pricing: '236bzx2',
  HelpAndSupport: 'ck2ic0y',
};

export const WorkspaceId = {
  AppsAndGamesId: WorkspacePC.AppsAndGames,
  BenefitsId: WorkspacePC.Benefits,
  BillingId: WorkspacePC.Billing,
  ClaimsId: 'um7pkr8',
  CollaborateId: WorkspacePC.Collaborate,
  CustomersId: WorkspacePC.Customers,
  CustomerResearchId: 'as87jkl',
  EdgeId: WorkspacePC.Edge,
  HardwareId: '6z0naak',
  IncentivesId: WorkspacePC.Incentives,
  InsightsId: WorkspacePC.Insights,
  MembershipId: WorkspacePC.Membership,
  MarketplaceOffersId: WorkspacePC.MarketplaceOffers,
  ReferralsId: WorkspacePC.Referrals,
  EarningsId: WorkspacePC.Earnings,
  PricingId: WorkspacePC.Pricing,
  QuotesId: '99gy1am',
  QuotesHelpId: 'd8j54ls',
  HelpAndSupportId: 'ck2ic0y',
};

export const Workspace = {
  WorkspaceProperty: 'workspace',
  WorkspaceCategoryProperty: 'workspaceCategory',
  None: 'None',
};

export const WorkspaceCategoryPc = {
  AccountSettings: 'Account Settings',
  Enrollment: 'Enrollment',
  APIandIntegration: 'APIs and Integration',
  ActionCenter: 'Action Center',
  customers: 'Customers',
};

export const ServiceHealthIds = {
  Customer: '16b1f772-6354-4d97-5901-274126e154de',
  Pricing: '99b197d0-bc63-13da-cf90-5c6b06175501',
  Earnings: 'a7194f58-f491-cec9-8cb1-736f516ff9ae',
  MPNBenefitsandCompetencies: 'b13ac5ef-6423-c7d6-7151-1fa89016d8d3',
  MarketplaceOffers: '89a763db-8e78-30a6-bd3e-daadc8f90b88',
  Incentives: '177ef1d1-4185-0bd7-0300-23d775d15eeb',
  Referrals: 'b7273e38-bab2-0616-9afc-c7d73c72647c',
  Billing: 'b855d1c0-3316-89b1-19b9-94cbae6a82d0',
  APIsandIntegration: 'fd8d33dd-46bd-983f-7a9b-04fe154ce5ce',
  AccountSettings: 'd46c37f4-8330-3366-8979-f4828da9cd87',
};
